import React, { useCallback, useRef, useState } from 'react';
import { namesAndIds } from '../../../../../../../types/shared/PrequalificationDataEntry';
import { usePersonalInformation } from '../../../../../providers/PersonalInformationProvider';
import { usePersonalInformationError } from '../../../../../providers/PersonalInformationErrorProvider';
import { useAutoFillFocus } from '../../../../../providers/AutoFillFocusProvider';
import AddressField from '../../../../../../FieldContainers/AddressFields/AddressField/AddressField';
import { regexValidation } from '../../../../../../../utils/cob-utils';
import { generateFieldErrorMessage } from '../../../../../../../utils/error-message';
import type { TAddressInputProps } from '../../Inputs.types';

// TODO: Follow up on CL change to use abreviated states instead of full state names.
// see useGooglePlacesAutoComplete.ts for where googe places parses the state value from api.
export default function MailingAddressInput({ addressValidationCheck, checkRegex, orangeAsterisksOnMobile, disabled = false }: TAddressInputProps): JSX.Element {
    const regexContainer = regexValidation();
    const addressRef = useRef<HTMLInputElement>(null);
    const [ showIcon, setShowIcon ] = useState(false);

    const {
        personalInformation: { MailingAddressLine1 },
        setSingleValue,
    } = usePersonalInformation();
    const {
        personalInformationError: {
            MailingAddressLine1: { isInError, required },
        },
        dispatch,
    } = usePersonalInformationError();

    const { autoFillFocusOnFocusHandler, autoFillFocusOnBlurHandler } =
        useAutoFillFocus();

    const setValue = useCallback((mailingAddressValue: string) => {
        const containsInvalidCharacters = regexContainer.disallow.invalid_address_characters.test(mailingAddressValue);

        if (containsInvalidCharacters) {
            mailingAddressValue = mailingAddressValue.replace(regexContainer.disallow.invalid_address_characters, '');
        }

        setSingleValue('MailingAddressLine1')(mailingAddressValue);
        setValid(true); 
    }, []);

    const setValid = useCallback((valid: boolean) => {
        dispatch({
            type: 'setValid',
            target: 'MailingAddressLine1',
            payload: valid,
        });
    }, []);

    const handleBlur = () => {
        autoFillFocusOnBlurHandler();
        let isPassingRegex = true;
        if (!document.querySelector('.pcaselected:hover')) {
            addressValidationCheck();
            isPassingRegex = checkRegex('Mail', 'mailing_address', MailingAddressLine1, 'MailingAddressLine1');
        }
        setShowIcon(isPassingRegex);
    };
    return (
        <div className='PqDataEntryForm__inputRow' id='mailingAddress-field-container'>
            <AddressField
                {...namesAndIds.MailingAddressLine1}
                ref={addressRef}
                required={required}
                value={MailingAddressLine1}
                maxLength = {100}
                setValueCallback={setValue}
                alternate
                error={isInError} 
                invalidErrorMessage={generateFieldErrorMessage('Mailing Address', 'thirdParty', 'address')}
                errorText={generateFieldErrorMessage('Mailing Street Address', 'missingValue')}
                requiredMessage={generateFieldErrorMessage('Mailing Street Address', 'missingValue')}
                onFocusCallback={() => {
                    autoFillFocusOnFocusHandler();
                    setShowIcon(false);
                }}
                onBlurCallback={handleBlur}
                onKeyDownCallback={e => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                    }
                }}
                disabled={disabled}
                useOutsideValidation={showIcon}
                useSuccessIcon
                showSuccessIcon={disabled || undefined}
                orangeAsterisksOnMobile={orangeAsterisksOnMobile}
            />
        </div>
    );
}
